import axios from "../config/axios.v2";
import { ENQUIRY_URL, enquiryByIdUrl } from "./enquiry.url.service";

const unwrap = (res) => res.data?.data ?? res.data;
const unwrapList = (res) => ({
  data: res.data?.datas || res.data,
  pagination: res.data?.pagination ?? {}
});

const handleError = (err) => {
  console.log("enquiryService err::", err);
  throw err;
};

const EnquiryService = {
  // params: { page, limit, service, status }
  getAll: (params) => axios.get(ENQUIRY_URL, { params }).then(unwrapList).catch(handleError),
  getById: (id) => axios.get(enquiryByIdUrl(id)).then(unwrap).catch(handleError),
  update: (id, payload) => axios.patch(enquiryByIdUrl(id), payload).then(unwrap).catch(handleError),
  remove: (id) => axios.delete(enquiryByIdUrl(id)).then(unwrap).catch(handleError)
};

export default EnquiryService;
